import { render, staticRenderFns } from "./PlatformElderByAssessment.vue?vue&type=template&id=a0da1564&scoped=true&"
import script from "./PlatformElderByAssessment.vue?vue&type=script&lang=js&"
export * from "./PlatformElderByAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0da1564",
  null
  
)

export default component.exports